import { render, staticRenderFns } from "./GSchoolClasses.vue?vue&type=template&id=61718666&scoped=true&"
import script from "./GSchoolClasses.vue?vue&type=script&lang=ts&"
export * from "./GSchoolClasses.vue?vue&type=script&lang=ts&"
import style0 from "./GSchoolClasses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61718666",
  null
  
)

export default component.exports